import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "modules-for-advanced-reporting"
    }}>{`Modules for advanced reporting`}</h1>
    <p>{`Advanced reporting functionality is implemented in the following Commerce modules.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/Analytics/README.md"
      }}>{`Analytics`}</a>{` implements the following:`}</p>
    <ul>
      <li parentName="ul">{`Enabling subscription to Adobe Commerce Reporting and automatic re-subscription`}</li>
      <li parentName="ul">{`Changing the base URL without changing the Adobe Commerce Reporting account`}</li>
      <li parentName="ul">{`Declaring the configuration schemas for `}<a parentName="li" {...{
          "href": "data-collection.md"
        }}>{`report data collection`}</a></li>
      <li parentName="ul">{`Collecting the Commerce instance data as reports for Commerce Reporting`}</li>
      <li parentName="ul">{`Introducing API that provides the collected data`}</li>
      <li parentName="ul">{`Extending the Commerce configuration with the module parameters:`}
        <ul parentName="li">
          <li parentName="ul">{`Subscription status (enabled/disabled)`}</li>
          <li parentName="ul">{`Industry (a business area in which the instance website works)`}</li>
          <li parentName="ul">{`Time of data collection (time of the day when the module collects data)`}</li>
        </ul>
      </li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/CatalogAnalytics/README.md"
      }}>{`CatalogAnalytics`}</a>{` configures data definitions for data collection related to the Catalog module entities`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/CustomerAnalytics/README.md"
      }}>{`CustomerAnalytics`}</a>{` configures data definitions for data collection related to the Customer module entities`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/QuoteAnalytics/README.md"
      }}>{`QuoteAnalytics`}</a>{` configures data definitions for data collection related to the Quote module entities`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/ReviewAnalytics/README.md"
      }}>{`ReviewAnalytics`}</a>{` configures data definitions for data collection related to the Review module entities`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/SalesAnalytics/README.md"
      }}>{`SalesAnalytics`}</a>{` configures data definitions for data collection related to the Sales module entities`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/WishlistAnalytics/README.md"
      }}>{`WishlistAnalytics`}</a>{` configures data definitions for data collection related to the Wishlist module entities`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      